<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-toolbar flat>
      <v-toolbar-title>{{$t('WpCustomer.CustomerTitle')}}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newItem()">
            <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpCustomer.buttonnewCustomer')}}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-form 
            ref="form"
            v-model="valid"
            lazy-validation>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" sm="12" md="12">
                  <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                  <v-text-field
                    v-model="vDataTable.editedItem.cust_no"
                    dense
                    :label="$t('รหัสหน่วยงาน')"
                    required
                    :rules="[rules.required]"
                    outlined
                    style="font-size: 15px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -16px;">
                    <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                  <v-text-field
                    v-model="vDataTable.editedItem.cust_name"
                    dense
                    :label="$t('ชื่อหน่วยงาน')"
                    required
                    outlined
                    :rules="[rules.required]"
                    style="font-size: 15px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -16px;">
                    <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                  <v-text-field
                    v-model="vDataTable.editedItem.contact_name"
                    dense
                    :label="$t('ชื่อผู้ติดต่อ')"
                    outlined
                    style="font-size: 15px;"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="vDataTable.editedItem.contact_email"
                    dense
                    :label="$t('อีเมลผู้ติดต่อ')"
                    outlined
                    style="font-size: 15px;"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="phoneNumber"
                    dense
                    :label="$t('เบอร์โทรผู้ติดต่อ')"
                    outlined
                    style="font-size: 15px;"
                  ></v-text-field>
                </v-col>
                <!-- v-model="vDataTable.editedItem.country_phone" -->
                <!-- <v-col cols="12" sm="12" md="2">
                  <v-text-field class="ma-0 pa-0" hide-details
                    outlined
                    name="input-7-4"
                    v-model="vDataTable.editedItem.city_area_code"
                    rows="4"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-text-field class="ma-0 pa-0" hide-details
                    outlined
                    name="input-7-4"
                    v-model="vDataTable.editedItem.local_phone"
                    rows="4"
                  ></v-text-field>
                </v-col> -->
                <v-col cols="12" sm="12" md="12" style="margin-top: -16px;">
                  <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                  <v-text-field
                  v-model="vDataTable.editedItem.PDFPassword"
                    dense
                    :label="$t('รหัสสำหรับเปิดไฟล์ PDF')"            
                    outlined
                    style="font-size: 15px;"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -16px;">
                  <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                <v-autocomplete
                    outlined
                    dense
                    :label="$t('ประเภทการชำระเงิน')"
                    v-model="vDataTable.editedItem.payment_code"
                    :items="paymentTypeList"
                    item-value="code"
                    item-text="description"
                    style="font-size: 15px;"
                    required
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -16px;">
                  <div style="margin-bottom: -10px;">
                    <span class="red--text"><strong>* </strong></span>
                  </div>
                <v-autocomplete
                    outlined
                    dense
                    :label="$t('Credit Terms')"
                    v-model="vDataTable.editedItem.payterm_code"
                    :items="paymentTermList"
                    item-value="code"
                    item-text="description"
                    style="font-size: 15px;"
                    required
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters class="mt-n2">
                    <v-col cols="auto" class="pa-0 mr-6 d-flex align-center">
                      <v-checkbox
                        v-model="vDataTable.editedItem.active"
                        dense
                        hide-details
                        false-value="I"
                        true-value="A"
                        class="ma-0 pa-0"
                      >
                        <template v-slot:label>
                          <span class="text--primary">เปิดใช้งาน</span>
                        </template>
                      </v-checkbox>
                    </v-col>

                    <v-col cols="auto" class="pa-0 d-flex align-center">
                      <v-switch
                        v-model="vDataTable.editedItem.is_ai_enabled"
                        dense
                        hide-details
                        inset
                        :color="vDataTable.editedItem.is_ai_enabled ? 'success' : 'grey'"
                        class="ma-0 pa-0"
                      >
                        <template v-slot:label>
                          <div class="d-flex align-center">
                            <span class="text--primary">AI</span>
                            <span class="ml-2 grey--text">
                              ({{ vDataTable.editedItem.is_ai_enabled ? 'Active' : 'Inactive' }})
                            </span>
                          </div>
                        </template>
                      </v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- <v-col cols="2" sm="2" md="2" style="margin-top: -15px;">
                  <v-checkbox outlined dense hide-details
                    false-value="I"
                    true-value="A"
                    ref="checkBoxIHCSpecialStaining"
                    v-model="vDataTable.editedItem.active">
                    <template v-slot:label>
                      <div><span class='text--primary'>เปิดใช้งาน</span></div>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="2" sm="2" md="2" style="margin-top: -15px;">
                  <v-switch
                    v-model="vDataTable.editedItem.is_ai_enabled"
                    inset
                    dense
                    hide-details
                    :color="vDataTable.editedItem.is_ai_enabled ? 'success' : 'grey'"
                    class="active-switch"
                  >
                    <template v-slot:label>
                      <div>
                        <span class="text--primary">เปิดใช้งาน</span>
                        <span class="text--primary">
                          ({{ vDataTable.editedItem.is_ai_enabled ? 'Active' : 'Inactive' }})
                        </span>
                      </div>
                    </template>
                  </v-switch>
                </v-col> -->
              </v-row>
            </v-container>
          </v-form>
          </v-card-text>
          <v-card-actions style="margin-top: -20px;">
            <v-spacer></v-spacer>
              <v-btn outlined color="success" @click="save">{{$t('save')}}</v-btn>
              <v-btn outlined color="error" @click="close">{{$t('cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-divider class="mx-1" inset vertical></v-divider>
      <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
        <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('WpCustomer.buttonDeleteCustomer')}}
      </v-btn>
      <v-divider class="mx-1" inset vertical></v-divider>
      <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveCustomer(appName)">
        <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
    </v-toolbar>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="cust_skey"
      class="fill-height">
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <!-- eslint-disable-next-line -->
      <!-- <template v-slot:[`item.contact_tel`]="{ item }">
        <span v-if="item.contact_tel === null">{{formatPhone(item.local_phone)}}</span>
        <span v-else>{{item.contact_tel}}</span>
      </template> -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active == 'A'" large color="green">
          {{ item.active == 'A'? 'mdi-checkbox-marked-circle' : 'mdi-close-circle'}}
        </v-icon>
        <v-icon v-if="item.active != 'A'" large color="red">
          {{ item.active == 'A'? 'mdi-checkbox-marked-circle' : 'mdi-close-circle'}}
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-alert type="info" border="bottom" colored-border elevation="2">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table> 
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import { VueEditor, Quill } from 'vue2-editor'
/* import { consoleLog } from '../node_modules-/echarts/lib/util/log' */
var Keyboard = Quill.import('modules/keyboard')
class CustomKeyboard extends Keyboard {
  static DEFAULTS = {
    ...Keyboard.DEFAULTS,
    bindings: {
      ...Keyboard.DEFAULTS.bindings,
      ['list autofill']: undefined,
    }
  }
}
Quill.register('modules/keyboard', CustomKeyboard)
export default {
  components: {
    VueEditor,
  },

  props: ['parentComponent'],

  data () {
    return {
      valid: false,
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
        required: value => !!value || 'กรุณากรอกข้อมูล.',
        select: value => !!value || 'กรุณาเลือกข้อมูล',
        emailRules: (value) => /^\w+([/.-]?\w+)*@\w+([/.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'รูปแบบอีเมลไม่ถูกต้อง',
        mobile: (value) => /^[0-9\-\s]+$/.test(value) || 'กรุณากรอกเฉพาะตัวเลข, ช่องว่าง หรือเครื่องหมาย "-" เท่านั้น',
        numberLength: (value) =>
          (value && (value.length > 10)) || 'กรุณากรอกจำนวนตัวเลขไม่เกิน 10 หลัก'
      },
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogDepartment: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedDepartmentIndex: -1,
        editedDepartmentItem: {
        },
        defaultDepartmentItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      progressMessage: '',
      departments: [],
      departmentEdit: true,
      vueEditorOrganGross: 'vue-editorOrganGrossCustomHeight200',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        /* [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], */
        /* [{ list: 'ordered' }, { list: 'check' }], */
        /* [{ indent: '-1' }, { indent: '+1' }], */
        [{ color: [] }],
        ['clean']
      ],
      editorSettings: {
        fomats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'align',
          'direction',
          'code-block',
          'formula',
          'image',
          'video'
        ],
      },
      paymentTypeList: [],
      paymentTermList: [],
      payTerm: '',
      showPayterm: false,
      phoneNumber: '',
      formattedPhoneNumber: ''
    }
  },

  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    formTitle () {
      return this.vDataTable.editedIndex === -1 ? this.$t('WpCustomer.newCustomer') : this.$t('WpCustomer.newCustomer')
    },
    formDepartmentTitle () {
      return this.vDataTable.editedDepartmentIndex === -1 ? this.$t('WpCustomer.newCustomerDepartment') : this.$t('WpCustomer.editCustomerDepartment')
    },
    headers () {
      return [
        { text: '', align: 'center', value: 'data-table-select' },
        // { text: 'skey', align: 'left', value: 'cust_skey', class: 'text-xl-left body-1 black--text' },
        { text: this.$t(''), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('รหัสหน่วยงาน'), value: 'cust_no', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ชื่อหน่วยงาน'), value: 'cust_name', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ชื่อผู้ติดต่อ'), value: 'contact_name', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('เบอร์โทรผู้ติดต่อ'), value: 'contact_tel', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('ประเภทชำระเงิน'), value: 'payment_type', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t(''), value: 'payment_term', align: 'left', class: 'text-xl-left body-1 black--text' },
        // { text: this.$t('สถานะการอนุมัติ'), value: 'verify_status', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: 'Active', value: 'active', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'department_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    offsetAppBar () {
      // return this.getShowAppBar ? 0 : this.getAppBarHeight
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
    computedHeaders () {
      // กรอง headers ตามเงื่อนไข
      return this.showPayterm ? this.headers : this.headers.filter((header) => header.value !== 'payment_term')
    },
    // formattedPhone() {
    //   return this.formatPhoneNumber(this.phoneNumber);
    // }
  },

  watch: {
    'dialog.dialogAddEdit' (val) {
      val || this.close()
    },
    phoneNumber (newValue) {
      this.phoneNumber = newValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3')
      // .replace(/\D/g, '')
      // let cleaned = newValue.replace(/\D/g, '')
      // console.log('newValue.length now', newValue.length)
      // if (newValue.length === 10 && newValue.length === 12) {
      //   console.log('doing if')
      //   this.phoneNumber = newValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3')
      // } else if ((newValue.length >= 9 && newValue.length <= 11) || (newValue.length > 12)) {
      //   this.phoneNumber = newValue.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1 $2 $3')
      // }
      // if (newValue.length === 9 || newValue.length > 10) {
      //   this.phoneNumber = newValue.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1 $2 $3')
      // }
      // else {
      //   console.log('doing else')
      //   this.phoneNumber = newValue.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1 $2 $3')
      // }
      // this.phoneNumber = newValue.length === 12 ? newValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3') : newValue.replace(/^(\d{2})(\d{3})(\d{4})$/, '$1 $2 $3')
      // replace(/^(\d{3})(\d{3})(\d{4})$/, '$1 $2 $3')
      // console.log('phoneNumber', this.phoneNumber)
      // if (cleaned.length > 10 || cleaned.length === 9) {
      //   this.phoneNumber = `${cleaned.slice(0, 2)} ${cleaned.slice(2, 6)} ${cleaned.slice(6, cleaned.length)}`
      // }
    }
  },

  async created () {
    this.retrieveDepartment()
    this.retrievePaymentType()
    this.retrievePaymentTerm()
    await this.retrieveCustomer(this.appName)
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    /* getIp () {
      console.log('getip')
      this.axios.post('https://api.db-ip.c../free/self', {
      })
        .then(response => {
          console.log(response, 'response')
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    }, */
    selectDepartment (department) {
    },
    initialize () {
      this.vDataTable.selected = []
      this.vDataTable.editedIndex = -1
      this.vDataTable.editedItem = {
        win_name: '',
        window_comment: ''
      }
      this.vDataTable.defaultItem = {
        win_name: '',
        window_comment: ''
      }
    },
    newCustomerDepartment (item) {
      this.vDataTable.editedItem = Object.assign({}, item)
      // this.dialogDepartment = true
      this.departmentEdit = false
    },
    expandCollapseNode (expand) {
      if (expand) {
        this.vDataTable.expanded = this.vDataTable.data
      } else {
        this.vDataTable.expanded = []
      }
    },
    findCopyHeader (skey) {
      return this.vDataTable.data.find(function (x) {
        return (x.skey === skey)
      })
    },
    findDepartment (custSkey) {
      return this.vDataTable.data.find(function (x) {
        return (x.cust_skey === custSkey)
      }).wp_customer_department
    },
    findNodeSelectedDepartment (custSkey) {
      return this.vDataTable.data.find(function (x) {
        return (x.cust_skey === custSkey)
      }).selectedDepartment
    },
    retrieveDepartment () {
      this.axios.post(process.env.VUE_APP_API + '/customer_department/retrieveDepartment' + process.env.VUE_APP_DATABASE_TYPE, {
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.departments = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    closeDepartment () {
      this.dialog.dialogDepartment = false
      this.$nextTick(() => {
        this.vDataTable.editedDepartmentItem = Object.assign({}, this.vDataTable.defaultDepartmentItem)
        this.vDataTable.editedDepartmentIndex = -1
      })
    },
    async saveDepartment () {
      await this.addCustomerDepartment(this.vDataTable.editedItem.cust_skey,
        this.vDataTable.editedDepartmentItem.department_skey)
      this.closeDepartment()
    },
    async addCustomerDepartment (custSkey, departmentSkey) {
      await this.axios.post(process.env.VUE_APP_API + '/customer_department/addCustomerDepartment' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: custSkey,
        department_skey: departmentSkey
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.editedDepartmentItem.department_skey = response.data.data.department_skey
            this.vDataTable.editedDepartmentItem.department_name = this.departments.find(function (x) {
              return (x.department_skey === departmentSkey)
            }).department_name
            this.findDepartment(custSkey).push(this.vDataTable.editedDepartmentItem)
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async deleteDepartmentConfirm (item) {
      console.log('delete department')
      this.vDataTable.editedDepartmentIndex = this.findDepartment(item.cust_skey).indexOf(item)
      this.vDataTable.editedDepartmentItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat('Are you sure delete department {} node {}?', item.department_comment, item.convenient_time_name),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteDepartment(item)
          if (val !== undefined) {
            var selectedDepartment = this.findNodeSelectedDepartment(item.cust_skey)
            if (selectedDepartment.indexOf(item) >= 0) {
              selectedDepartment.splice(selectedDepartment.indexOf(item), 1)
            }
          }
          this.vDataTable.editedDepartmentItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedDepartmentIndex = -1
        }
      })
    },
    async deleteDepartment (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var custSkey = item.cust_skey
        var departmentSkey = item.department_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/customer_department/deleteCustomerDepartment' + process.env.VUE_APP_DATABASE_TYPE, {
          cust_skey: custSkey,
          department_skey: departmentSkey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.findDepartment(item.cust_skey).indexOf(item) >= 0) {
                this.findDepartment(item.cust_skey).splice(this.findDepartment(item.cust_skey).indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    checkDeleteselectedDepartment (item) {
      if (this.findNodeSelectedDepartment(item.cust_skey).length > 0) {
        this.$swal({
          text: this.$t('WpCustomer.confirmCustomerDepartmentDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteDepartmentSelected(item)
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpCustomer.messagedeleteDepartmentNotSelected')})
      }
    },
    async deleteDepartmentSelected (item) {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.findNodeSelectedDepartment(item.cust_skey), async function (x) {
        this.progressMessage = this.stringFormat(this.$t('ConvenientTimeMaint.progressMessageNodeDepartmentDelete'), x.convenient_time_name)
        var val = await this.deleteDepartment(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        var selectedDepartment = this.findNodeSelectedDepartment(item.cust_skey)
        selectedDepartment.splice(selectedDepartment.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async retrieveCustomer (appName) {
      console.log('retrieveCustomer')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/lis_customer/retrieveCustomer' + process.env.VUE_APP_DATABASE_TYPE, {
        app_name: appName
      })
        .then(response => {
          if (response.data.isSuccess) {
            console.log('response', response)
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async addCustomer (datas, phone) {
      // custNo, custName, contactName, contactEmail, pmtType, pmtTerm, active, PDFPassword
      var formatPhone = this.formatTel(phone)
      if (!datas.cust_no) {
        await this.$swal({type: 'error', title: 'กรุณาระบุรหัสหน่วยงาน'})
        // return
      } else if (!datas.cust_name) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อหน่วยงาน'})
        // return
      } else if (!datas.contact_name) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อผู้ติดต่อ'})
        // return
      } else if (!datas.payment_code) {
        await this.$swal({type: 'error', title: 'กรุณาเลือกประเภทการชำระเงิน'})
        // return
      } else {
        if (this.$refs.form.validate()) {
          await this.axios.post(process.env.VUE_APP_API + '/lis_customer/addCustomer' + process.env.VUE_APP_DATABASE_TYPE, {
            cust_no: datas.cust_no,
            cust_name: datas.cust_name,
            contact_name: datas.contact_name,
            contact_email: datas.contact_email,
            country_phone: formatPhone.length === 10 ? formatPhone.slice(0, 3) : formatPhone.slice(0, 2),
            city_area_code: formatPhone.length === 10 ? formatPhone.slice(3, 6) : formatPhone.slice(2, 5),
            local_phone: formatPhone.length === 10 ? formatPhone.slice(6) : formatPhone.slice(5),
            pmt_type: datas.payment_code,
            pmt_term: datas.payterm_code,
            active: datas.active,
            PDFPassword: datas.PDFPassword,
            is_ai_enabled: datas.is_ai_enabled
          })
          .then(response => {
            if (response.data.isSuccess) {
              this.retrieveCustomer()
              this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddEdit = false
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        }
      }
    },
    async updateCustomer (datas, mobileNumber) {
      // custSkey, custNo, custName, contactName, contactEmail, localPhone, pmtType, pmtTerm, active, PDFPassword
      var formatPhone = this.formatTel(mobileNumber)
      if (!datas.cust_no) {
        await this.$swal({type: 'error', title: 'กรุณาระบุรหัสหน่วยงาน'})
        return
      }
      if (!datas.cust_name) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อหน่วยงาน'})
        return
      }
      if (!datas.PDFPassword) {
        await this.$swal({type: 'error', title: 'กรุณาระบุรหัสผ่านดาวน์โหลดไฟล์'})
        return
      }
      if (!datas.contact_name) {
        await this.$swal({type: 'error', title: 'กรุณาระบุชื่อผู้ติดต่อ'})
        return
      }
      if (!datas.payment_code) {
        await this.$swal({type: 'error', title: 'กรุณาเลือกประเภทการชำระเงิน'})
        return
      }
      if (this.$refs.form.validate()) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_customer/updateCustomer' + process.env.VUE_APP_DATABASE_TYPE, {
          cust_skey: datas.cust_skey,
          cust_no: datas.cust_no,
          cust_name: datas.cust_name,
          contact_name: datas.contact_name,
          contact_email: datas.contact_email,
          country_phone: formatPhone.length === 10 ? formatPhone.slice(0, 3) : formatPhone.slice(0, 2),
          city_area_code: formatPhone.length === 10 ? formatPhone.slice(3, 6) : formatPhone.slice(2, 5),
          local_phone: formatPhone.length === 10 ? formatPhone.slice(6) : formatPhone.slice(5),
          pmt_type: datas.payment_code,
          pmt_term: datas.payterm_code,
          active: datas.active,
          PDFPassword: datas.PDFPassword,
          is_ai_enabled: datas.is_ai_enabled
        })
        .then(response => {
          console.log(response)
          if (response.data.isSuccess) {
            Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
            this.retrieveCustomer()
            this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
            this.dialog.dialogAddEdit = false
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      }
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpCustomer.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpCustomer.messageDeleteNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')

      var del = []

      await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('WpCustomer.progressMessageDelete'), x.cust_name)
        var val = await this.deleteCustomer(x)

        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      for (const x in del) {
        this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
      }

      this.dialog.dialogProgress = false
    },
    async deleteCustomer (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        var custSkey = item.cust_skey
        var valRet
        await this.axios.post(process.env.VUE_APP_API + '/lis_customer/deleteCustomer' + process.env.VUE_APP_DATABASE_TYPE, {
          cust_skey: custSkey
        })
          .then(async response => {
            if (response.data.isSuccess) {
              if (this.vDataTable.data.indexOf(item) >= 0) {
                this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
              }
              this.$swal({type: 'success', title: response.data.reasonText, showConfirmButton: false, timer: 1500})
              valRet = item
            } else {
              await this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        return valRet
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    formatTel (item) {
      item = item.replace(/\s/g, '')
      return item
    },
    formatPhoneNumber (newValue) {
      const cleaned = phone.replace(/[^0-9-ต่อ\s]/g, '')
    },
    newItem () {
      // this.vDataTable.editedItem.contact_name = ''
      this.vDataTable.editedItem.contact_email = ''
      this.vDataTable.editedItem.local_phone = ''
      // this.vDataTable.editedItem.country_phone = ''
      this.vDataTable.editedItem.city_area_code = ''
      // this.vDataTable.editedItem.payment_code = ''
      this.vDataTable.editedItem.active = 'A'
      this.vDataTable.editedItem.company_flag = 'N'
    },
    editItem (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.phoneNumber = this.vDataTable.editedItem.contact_tel === null ? this.vDataTable.editedItem.local_phone : this.vDataTable.editedItem.contact_tel
      this.dialog.dialogAddEdit = true
    },
    editDepartmentItem (item) {
      this.departmentEdit = true
      this.vDataTable.editedDepartmentIndex = this.findDepartment(item.cust_skey).indexOf(item)
      this.vDataTable.editedDepartmentItem = Object.assign({}, item)
      this.dialog.dialogDepartment = true
    },
    async deleteItemConfirm (item) {
      this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
      this.vDataTable.editedItem = Object.assign({}, item)
      this.$swal({
        text: this.stringFormat(this.$t('WpCustomer.confirmDelete'), item.cust_name),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then(async (result) => {
        if (result) {
          var val = await this.deleteCustomer(item)
          if (val !== undefined) {
            if (this.vDataTable.selected.indexOf(this.vDataTable.editedItem) >= 0) {
              this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(this.vDataTable.editedItem), 1)
            }
          }
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        }
      })
    },
    close () {
      this.dialog.dialogAddEdit = false
      this.$refs.form.reset()
      this.$nextTick(() => {
        this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
        this.vDataTable.editedIndex = -1
      })
    },
    async save () {
      // console.log('vDataTable.editedItem', this.vDataTable.editedItem)
      if (this.vDataTable.editedIndex > -1) {
        await this.updateCustomer(this.vDataTable.editedItem, this.phoneNumber)
        // this.vDataTable.editedItem.cust_skey,
        // this.vDataTable.editedItem.cust_no,
        // this.vDataTable.editedItem.cust_name,
        // this.vDataTable.editedItem.contact_name,
        // this.vDataTable.editedItem.contact_email,
        // this.vDataTable.editedItem.country_phone,
        // this.vDataTable.editedItem.city_area_code,
        // this.vDataTable.editedItem.local_phone,
        // this.vDataTable.editedItem.payment_code,
        // this.vDataTable.editedItem.payterm_code,
        // this.vDataTable.editedItem.active,
        // this.vDataTable.editedItem.PDFPassword
      } else {
        await this.addCustomer(this.vDataTable.editedItem, this.phoneNumber)
        //   this.vDataTable.editedItem.cust_no,
        //   this.vDataTable.editedItem.cust_name,
        //   this.vDataTable.editedItem.contact_name,
        //   this.vDataTable.editedItem.contact_email,
        //   this.vDataTable.editedItem.country_phone,
        //   this.vDataTable.editedItem.city_area_code,
        //   this.vDataTable.editedItem.local_phone,
        //   this.vDataTable.editedItem.payment_code,
        //   this.vDataTable.editedItem.payterm_code,
        //   this.vDataTable.editedItem.active,
        //   this.vDataTable.editedItem.PDFPassword,
      }
    },
    pickFileInsert (image) {
      this.$refs.imageInsert.click()
    },
    handleFileSelectInsert: function (event) {
      var input = event.target
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          var binaryData = e.target.result
          this.vDataTable.editedItem.filename = input.files[0].name
          this.vDataTable.editedItem.picture_base64 = window.btoa(binaryData)
        }
        reader.readAsBinaryString(input.files[0])
      }
    },
    async copyHeader () {
      console.log(this.vDataTable.editedItem.skey, 'copyHeader')
      console.log(this.findCopyHeader(this.vDataTable.editedItem.skey), 'copyHeader2')
      const guarantee = await this.findCopyHeader(this.vDataTable.editedItem.skey)
      console.log(this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name, 'this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name')
      this.vDataTable.editedDepartmentItem.guarantee_name = await this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_name
      this.vDataTable.editedDepartmentItem.guarantee_detail = await this.findCopyHeader(this.vDataTable.editedItem.skey).guarantee_detail
      console.log(this.vDataTable.editedDepartmentItem, 'this.vDataTable.editedDepartmentItem')
    },
    async retrievePaymentType () {
      await this.axios.post(process.env.VUE_APP_API + '/lis_customer/retrievePaymentType' + process.env.VUE_APP_DATABASE_TYPE, {
      })
      .then(response => {
        if (response.data.isSuccess) {
          this.paymentTypeList = response.data.data
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
      console.log(this.paymentTypeList, 'test')
    },
    async retrievePaymentTerm () {
      await this.axios.post(process.env.VUE_APP_API + '/lis_customer/retrievePaymentTerm' + process.env.VUE_APP_DATABASE_TYPE, {
      })
      .then(response => {
        if (response.data.isSuccess) {
          this.paymentTermList = response.data.data
        } else {
          this.$swal({type: 'error', title: response.data.reasonText})
        }
      })
      .catch(e => {
        this.$swal({type: 'error', title: e.message})
      })
    }
  },
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
#vue-editorOrganGrossCustomHeight200 {
  font-family: Arial, Helvetica, sans-serif;
  width: 768px;
  height: 200px;
  caret-color: black;
}
</style>